import { occFetch, occUrl } from "~/app/api/occ/occFetch";

interface Props {
  email: string;
  firstName: string;
  lastName: string;
  note: string;
  sharedWishlist: string;
  selectedWishlistName: string;
}

interface ShareWishlistViaEmailResult {
  error?: string;
}

const INVALID_EMAIL_ERROR = "error.invalidEmail";
const GENERIC_ERROR = "generic.error.ajax";

function normalizeResult(response: Response, result: ShareWishlistViaEmailResult): ShareWishlistViaEmailResult {
  if (result.error === INVALID_EMAIL_ERROR) {
    return result;
  }

  return response.ok ? {} : { error: GENERIC_ERROR };
}

export const sendWishlistViaEmail = async (data: Props): Promise<ShareWishlistViaEmailResult> => {
  const url = occUrl("/sendWishlistViaEmail");

  const response = await occFetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  const result = (await response.json().catch(() => ({}))) as ShareWishlistViaEmailResult;
  return normalizeResult(response, result);
};
